/**
 * 全局多语言（不依赖 vue-i18n，语法简单，适配低版本 Android WebView）
 * 语言码：zh-Hans（简体）| zh-Hant（繁体）| en（英文）
 * 持久化 key 与桌边付共用：localStorage 'locale'
 */
import zhHans from './zh-Hans'
import zhHant from './zh-Hant'
import en from './en'
import { applyVantLocale } from './vantLocale'

var STORAGE_KEY = 'locale'
var DEFAULT_LOCALE = 'zh-Hans'

var SUPPORTED = {
  'zh-Hans': true,
  'zh-Hant': true,
  en: true
}

var LEGACY = {
  zh: 'zh-Hans',
  'zh-CN': 'zh-Hans',
  'zh-TW': 'zh-Hant',
  'zh-HK': 'zh-Hant',
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
  en: 'en'
}

var messages = {
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
  en: en
}

var localeVm = null

function normalizeLocale(raw) {
  if (raw == null || raw === '') {
    return DEFAULT_LOCALE
  }
  if (LEGACY[raw]) {
    return LEGACY[raw]
  }
  if (SUPPORTED[raw]) {
    return raw
  }
  return DEFAULT_LOCALE
}

export function getLocale() {
  try {
    var raw = localStorage.getItem(STORAGE_KEY)
    var locale = normalizeLocale(raw)
    if (raw !== locale) {
      try {
        localStorage.setItem(STORAGE_KEY, locale)
      } catch (e2) {}
    }
    return locale
  } catch (e) {
    return DEFAULT_LOCALE
  }
}

export function setLocale(lang) {
  var locale = normalizeLocale(lang)
  if (!SUPPORTED[locale]) {
    return
  }
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch (e) {}
  applyVantLocale(locale)
  if (localeVm) {
    localeVm.locale = locale
  }
}

export function t(key) {
  if (localeVm) {
    // 读取 locale 以触发依赖收集，切换语言后页面可刷新文案
    var _loc = localeVm.locale
  }
  var locale = getLocale()
  var table = messages[locale] || messages['zh-Hans']
  if (table[key] != null && table[key] !== '') {
    return table[key]
  }
  if (messages['zh-Hans'][key] != null) {
    return messages['zh-Hans'][key]
  }
  return key
}

/** 占位符替换：t('a_{0}_b', 'x') => a_x_b */
export function tf(key) {
  var args = Array.prototype.slice.call(arguments, 1)
  var s = t(key)
  var i
  for (i = 0; i < args.length; i++) {
    s = s.split('{' + i + '}').join(String(args[i]))
  }
  return s
}

export var LOCALE_OPTIONS = [
  { code: 'zh-Hans', labelKey: 'lang_zh_hans' },
  { code: 'zh-Hant', labelKey: 'lang_zh_hant' },
  { code: 'en', labelKey: 'lang_en' }
]

export function install(Vue) {
  applyVantLocale(getLocale())
  localeVm = new Vue({
    data: function () {
      return {
        locale: getLocale()
      }
    }
  })

  Vue.prototype.$t = function (key) {
    return t(key)
  }
  Vue.prototype.$tf = function (key) {
    var args = Array.prototype.slice.call(arguments, 1)
    return tf.apply(null, [key].concat(args))
  }
  Vue.prototype.$getLocale = function () {
    return getLocale()
  }
  Vue.prototype.$setLocale = function (lang) {
    setLocale(lang)
  }
  Vue.prototype.$localeOptions = LOCALE_OPTIONS
}



// WEBPACK FOOTER //
// ./src/locale/i18n.js